import {
  Box,
  CircularProgress,
  Container,
  Divider,
  Grid,
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import { useEffect, useState } from 'react'
import 'react-credit-cards/es/styles-compiled.css'
import { useHistory } from 'react-router-dom'
import MultiplasFormas from 'src/components/pagamento/multiplasFormas'
import UBox from 'src/components/ui/Ubox'
import { SynRoutes } from 'src/core/consts/synRoutes'
import usePagamento from 'src/hooks/usePagamento'
import { useQueryParams } from 'src/hooks/useQuery'
import { Alert } from '@material-ui/lab'
import InfoResponsabilidade from 'src/components/pagamento/infoResponsabilidade'
import { useQuery } from 'react-query'
import { obterInformacoesParaFinanciamento } from 'src/api/financiamento'
import { showNotificationErrorAPI } from 'src/core/helpers/notification'

export default function Pagamento() {
  const query = useQueryParams()

  const { data: informacoesFinanciamento, isLoading } = useQuery(
    ['informacoesFinanciamento', query.get('p')],
    async () => {
      try {
        var response = await obterInformacoesParaFinanciamento(query.get('p'))
        return response.data
      } catch (error) {
        showNotificationErrorAPI(error)
        return null
      }
    }
  )

  if (isLoading) {
    return (
      <UBox
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Box textAlign="center">
          <CircularProgress />
          <div>Carregando...</div>
        </Box>
      </UBox>
    )
  }

  return (
    <UBox
      style={{
        padding: 0,
        margin: 0,
        width: '100%',
        height: '100vh',
        overflow: 'hidden'
      }}
    >
      <iframe
        src={informacoesFinanciamento?.urlFinanciamento}
        style={{ width: '100%', height: '100vh', overflow: 'hidden' }}
      />
    </UBox>
  )
}
